"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_student(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "33074f81-d8be-4ccb-85e0-99e9b63dec4c",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "student-mid"), /*#__PURE__*/React.createElement("g", {
    id: "8b9a72e9-d7a9-4e75-973a-fa29dc04baaa",
    "data-name": "student-mid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "6fa0358a-fdbe-4eec-a797-50fd27a32f79",
    "data-name": "<Path>",
    d: "M21.44,77c-4.59-2.32-4.59-6,0-8.3l66.35-37c4.59-2.32,12-2.32,16.61,0L170.56,67c4.59,2.31,4.59,6,0,8.29l-66.07,37c-4.59,2.32-12,2.32-16.58,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "0b1d5e24-da00-47d7-a9f0-8b6810a48056",
    "data-name": "<Path>",
    d: "M146,89.61v42.93c0,4.16-.68,4.61-4.41,8S119,162,96,162s-42.41-18.21-45.87-21.45-4.17-3.82-4.17-8",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "32d424fa-c4f8-4534-aadb-8fb385514d68",
    "data-name": "<Path>",
    d: "M46,150V93.39c0-1.54,1-3.2,3.36-4.37L84,69",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }));
}

var _default = ic_student;
exports.default = _default;